import React from "react";
import Routes from "./routes/Routes";
import "./index.css";
import "./styles/util.css";
import WauthProvider from "./auth/WauthProvider";

function App() {
  return (
    <WauthProvider
      domain={process.env.REACT_APP_AUTH_SERVER}
      clientId={process.env.REACT_APP_AUTH_CLIENT_ID}
      redirectUri={window.location.origin + "/callback"}
    >
      <Routes />
    </WauthProvider>
  );
}

export default App;
